/* eslint-disable no-unused-vars */
import ReactDOM from 'react-dom/client'
import App from './App'
import style from './style.css'
ReactDOM.createRoot( document.getElementById( 'root' ) ).render( <App /> )
